module.exports = __webpack_public_path__ + "img/Mask Group 46.e197a389.svg";